const CalendarIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 18V7.5H16.5V16.5H18V1.5H14.25V0H12.75V1.5H5.25V0H3.75V1.5H0V19.5H16.9497L18 18H1.5ZM3.75 3V4.5H5.25V3H12.75V4.5H14.25V3H16.5V6H1.5V3H3.75Z"
        fill="#111113"
      />
    </svg>
  )
}

export default CalendarIcon
